import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, error, helperText, className = '', ...props }, ref) => {
        const inputClasses = `
            block w-full min-w-0 max-w-full rounded-lg border px-4 py-2 text-base
            focus:outline-hidden focus:ring-2
            disabled:opacity-50 disabled:cursor-not-allowed
            appearance-none
            ${
                error
                    ? 'border-red-500 focus:ring-red-500 text-red-900 dark:text-red-100'
                    : 'border-gray-300 dark:border-gray-600 focus:ring-blue-500 text-gray-900 dark:text-gray-100'
            }
            bg-white dark:bg-gray-800
        `;

        return (
            <div className="w-full min-w-0">
                {label && (
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        {label}
                    </label>
                )}
                <input ref={ref} className={`${inputClasses} ${className}`} {...props} />
                {error && <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>}
                {helperText && !error && (
                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{helperText}</p>
                )}
            </div>
        );
    },
);

Input.displayName = 'Input';
